import React, { Component } from 'react';
import _ from 'underscore';
import Slider from 'react-slick';
import 'rc-slider/assets/index.css';
import randomNumberGenerator from '../../utils';
import { statements as STATEMENTS } from '../../statements.json';
import './statements.css';
import Next from "../../assets/img/svg/right-arrow-red.svg";
import Previous from "../../assets/img/svg/left-arrow-red.svg";

const choiceLabels = ['Completely Disagree', null, null, 'Somewhat Agree', null, null, 'Completely Agree'];

const Choices = (props) => {
    const choiceClassName = (number) => `choice ${props.selectedAnswer === number ? 'selected' : ''}`;
    return (
        <div className="choices-container">
            <div className="choices-container-rating">
                {props.options.map((option, i) =>
                    <div className={`${choiceClassName(option[0])  } rating`} key={Math.random(i)} >
                        <button type="submit" onClick={() => props.selectAnswer(option[0])}>{option[0]}</button>
                    </div>
                )}
            </div>
            <div className="choices-container-label">
                {props.options.map((option, i) =>
                    option[1]? (<div className={choiceClassName(option[0])} key={Math.random(i)} >
                        <span className="choice-label">{option[1].split(' ')[0]}</span>
                        <span className="choice-label">{option[1].split(' ')[1]}</span>
                    </div>) : ''
                )}
            </div>
        </div>
    );
}

const Statement = ({ statement, onSelect, hasFocus }) => {
    const { text, answer} = statement;
    let containerClass='statement-container';
    if (hasFocus) containerClass += ' focus';
    return (<div className={containerClass}>
        <div className="statement-text">{text}</div>
        <Choices
            selectedAnswer={answer}
            selectAnswer={onSelect}
            options={_.zip(_.range(1, 8), choiceLabels)}
        />
        {/* <div className="progress-bar-container">
                    <div className={"progress-bar step-" + (current+1)}>
                        <div className="progress-label">{current+1} of {statements.length}</div>
                        <div className="progress-indicator"></div>
                    </div>
                </div> */}
    </div>);
};

class Statements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStatement: 0,
            statements: _.map(STATEMENTS, _.clone),
            scrollToBottom: false,
        };
        this.state.numberOfStatements = this.state.statements.length;
        this.hasAllAnswers = this.hasAllAnswers.bind(this);
        this.selectAnswer = this.selectAnswer.bind(this);
        this.prevArrow = this.prevArrow.bind(this);
        this.nextArrow = this.nextArrow.bind(this);
        this.submitAnswers = this.submitAnswers.bind(this);
    }

    hasAllAnswers(){ return _.all(this.state.statements, (s) => s.answer)}

    selectAnswer(clickedAnswer) {
        const {statements, currentStatement: current, numberOfStatements: total} = this.state;
        if (current < total - 1) {
            statements[current].answer = clickedAnswer;
            this.setState({
                statements: [...statements]
            }, () => {
                setTimeout(() => {
                    this.setState({
                        currentStatement: (this.hasAllAnswers() ? current : current + 1),
                    });
                    this.slider.slickGoTo(this.state.currentStatement);
                }, 500)
                });
        } else {
            statements[current].answer = clickedAnswer;
            this.setState({ statements: [...statements], scrollToBottom: true });
        }
    }

    prevArrow (){
        const {currentStatement: current} = this.state;
        return (
            current !== 0? <div>
                    <img src={Previous} alt="Previous"/>
            </div> : ''
        );
    }

    nextArrow () {
        const {statements, currentStatement: current} = this.state;
        return (
            statements[current].answer && (current !== statements.length - 1)? <div>
                    <img src={Next} alt="Next"/>
            </div>: ''
        );
    }

    submitAnswers() {
        this.props.onComplete(this.state.statements);
    }

    render() {
        const {statements, currentStatement: current} = this.state;

        // const prevArrow = <button className="slider-prev"><img src={require("../../assets/img/svg/left-arrow.svg")} alt="Next"/></button>
        const settings = {
            infinite: false,
            swipe: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
              },
              {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
              }
            ]
          };

        if(this.state.scrollToBottom){
            window.scrollTo(0,document.body.scrollHeight);
        }
        return (
            <div className="statements-container">
                <div className="description">Rate your agreement with the following statements</div>
                <div className="slider-container">
                    <Slider
                        {...settings}
                        prevArrow={this.prevArrow()}
                        nextArrow={this.nextArrow()}
                        className="statements-slider"
                        afterChange={(index) => { this.setState({ currentStatement: index }); }}
                        initialSlide={current} ref={(slider) => { this.slider = slider; }}
                        >
                            {statements.map((statement, index) =>
                                <Statement
                                    key={`${statement.header}_${randomNumberGenerator(index)}`}
                                    statement={statement}
                                    hasFocus={index === current}
                                    onSelect={this.selectAnswer}
                                    current={current}
                                    statements={statements}
                                />
                            )}
                    </Slider>
                    <div className="progress-bar-container">
                        <div className={`progress-bar step-${  current+1}`}>
                            <div className="progress-label">{current+1} of {statements.length}</div>
                            <div className="progress-indicator" />
                        </div>
                    </div>
                </div>
                <button type="submit"
                    className="go-to-results-button"
                    disabled={!this.hasAllAnswers()}
                    onClick={this.submitAnswers}>
                        Submit
                </button>
            </div>
        );
    }
}

export default Statements;



// WEBPACK FOOTER //
// ./src/components/Statements/statements.js